let directive = function() {
	return {
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {
			ngModel.$parsers.push(function(val) {
				if (val !== undefined) {
					return parseInt(val, 10);
				}
				
				return val;
			});
			ngModel.$formatters.push(function(val) {
				if (val !== undefined) {
					return '' + val;
				}

				return val;
			});
		}
	};
};

export default directive;


// WEBPACK FOOTER //
// ./app/shared/directives/convertToNumber.directive.js